<button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon">close</mat-icon>
</button>

<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <div class="row">
            <div class="col-md-12">
                <h2>
                    <b>Tracking Number</b> : {{data.custTrackingNo}}
                </h2>
                <hr>
            </div>
        </div>
        <div class="mat-dialog-content">
            <p class="mb-3"><b>Lender Name</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:
                &nbsp;&nbsp;&nbsp;&nbsp;{{data.lenderName}}</p>
            <P class="mb-3"><b>Vendor Name </b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:
                &nbsp;&nbsp;&nbsp;&nbsp;{{data.vendorId}}</P>
            <p class="mb-3"><b>Borrower Name </b>&nbsp;&nbsp;&nbsp;&nbsp;: &nbsp;&nbsp;&nbsp;&nbsp;{{data.borrower}}</p>
            <p class="mb-3"><b>Loan Number </b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:
                &nbsp;&nbsp;&nbsp;&nbsp;{{data.loanId}}</p>
            <p class="mb-3"><b>Property</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :
                &nbsp;&nbsp;&nbsp;&nbsp;{{data.property}}</p>
            <p class="mb-3"><b>Refund Amount</b>&nbsp;&nbsp;&nbsp;&nbsp; : &nbsp;&nbsp;&nbsp; &nbsp;${{data.refundAmt}}
            </p>
        </div>
    </div>
</div>